import { render, staticRenderFns } from "./ProductCompareButton.vue?vue&type=template&id=a102e940&"
import script from "./ProductCompareButton.vue?vue&type=script&lang=js&"
export * from "./ProductCompareButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports